/**
 * Returns amount formatted as with given currency
 * Ex. "1111,00 zł"
 *
 * @param {number} amount
 * @param {string} currency - ex. PLN, USD etc
 * @return {string}
 */
export const formatMoney = (amount, currency) =>
  amount.toLocaleString('pl', { style: 'currency', currency: currency })

/**
 * @param {number} number
 * @return {string}
 */
export const formatQuantity = (number) => number.toLocaleString('pl')
